import { Tag } from 'antd';
import { DataTableColumnHeader } from 'common/data-table-column-header';
import { dateTimeCell, linkCell } from 'utils/cell-formatter';

const permissionColors: Record<string, string> = {
  read: 'default',
  manage: 'blue',
  admin: 'red',
};

export const columnsGenerator = () => [
  {
    accessorKey: 'id',
    header: '',
    cell: ({ getValue }) =>
      linkCell({ getValue, path: '/admin/wealth/user-assignments' }),
  },
  {
    accessorKey: 'staff_email',
    header: 'Staff Email',
  },
  {
    accessorKey: 'staff_name',
    header: 'Staff Name',
  },
  {
    accessorKey: 'user_email',
    header: 'User Email',
  },
  {
    accessorKey: 'user_name',
    header: 'User Name',
  },
  {
    accessorKey: 'user_phone',
    header: 'User Phone',
  },
  {
    accessorKey: 'permission',
    header: 'Permission',
    cell: ({ getValue }) => {
      const permission = getValue();
      if (!permission) return '-';
      return (
        <Tag color={permissionColors[permission] || 'default'}>
          {permission}
        </Tag>
      );
    },
  },
  {
    accessorKey: 'created_at',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Created" />
    ),
    cell: dateTimeCell,
  },
];
